import clsx from 'clsx';
import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';

import { type IconDefinition, renderIcon } from '../util';

type LoadingIndicatorSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';

export interface LoadingIndicatorProps
    extends Omit<React.ComponentPropsWithoutRef<'div'>, 'aria-busy'> {
    spinnerIcon?: IconDefinition;
    size?: LoadingIndicatorSize | 'inherit' | number;
}

const sizes: Record<LoadingIndicatorSize, number> = {
    xsmall: 16,
    small: 16,
    medium: 16,
    large: 18,
    xlarge: 20,
};

/**
 * Loading spinner.
 */
export function LoadingIndicator(props: LoadingIndicatorProps): React.ReactElement {
    const { size = 'medium', spinnerIcon = Icon.Spinner, ...rest } = props;

    return (
        <div {...rest} aria-busy className={clsx('flex text-primary', rest.className)}>
            {renderIcon(spinnerIcon, {
                className: clsx(process.env.GITBOOK_PREDICTABLE_UI ? null : 'animate-spin'),
                size:
                    size === 'inherit' ? undefined : typeof size === 'string' ? sizes[size] : size,
            })}
        </div>
    );
}

/**
 * Icon signature for loading indicator.
 */
export function LoadingIndicatorIcon(props: { size?: number; className?: string }) {
    return <LoadingIndicator {...props} />;
}
